import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0B0B0B] border-t border-white/10 text-gray-400" data-testid="site-footer">
      <div className="container mx-auto px-6 py-14 max-w-6xl">
        <div className="grid md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="text-2xl font-bold tracking-tight text-white mb-3" style={{ fontFamily: 'Clash Display' }}>
              Move<span className="text-[#C6A97C]">More</span>
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              Treat the system, not the symptom. Move more with Brandon as your personal coach.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white mb-4 font-semibold">Company</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/refund-policy" data-testid="footer-refund-link" className="hover:text-[#C6A97C] transition-colors">Refund Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#C6A97C] transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#C6A97C] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/courses" className="hover:text-[#C6A97C] transition-colors">Browse Courses</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-widest text-white mb-4 font-semibold">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:brandon@burkebiokinetics.co.za" className="inline-flex items-start gap-2 hover:text-[#C6A97C] transition-colors break-all">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>brandon@burkebiokinetics.co.za</span>
                </a>
              </li>
              <li>
                <a href="https://wa.me/27822532520" target="_blank" rel="noopener noreferrer" className="inline-flex items-start gap-2 hover:text-[#C6A97C] transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>+27 82 253 2520</span>
                </a>
              </li>
              <li className="inline-flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>76 Reagent Road, Sea Point</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-gray-500">
          <div>&copy; {new Date().getFullYear()} MoveMore &middot; operated by Brandon Burke. All rights reserved.</div>
          <div>Treat the system, not the symptom.</div>
        </div>
      </div>
    </footer>
  );
}
